import React from 'react'
import styles from './IconVideoFile.module.scss'

export default function IconVideoFile() {
    return <div className={styles.root} />
}
